module.exports = __webpack_public_path__ + "img/figure-12.50dbe7d3.png";